import React from "react";
import { useNavigate } from "react-router-dom";

import FileUpload from "components/FileUpload/FileUpload";
import { Heading2 } from "widgets";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import FileUploadsHistory from "components/FileUploadsHistory/FileUploadsHistory";
import { UPLOAD_PACKAGE_SCHEDULE_SCRIPT_ID } from "constants/constants";

import styles from "./UploadPackageSchedule.module.scss";

const handleOnClickGoBackButton = (navigate) => {
  navigate("/homePage");
};

const UploadPackageSchedule = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.mainContainer}>
      <div
        className={styles.backContainer}
        onClick={() => handleOnClickGoBackButton(navigate)}
      >
        <ArrowBackIosIcon className={styles.icon} />
        <span className={styles.text}>Back</span>
      </div>
      <Heading2 heading="Upload Package Schedule" />
      <FileUpload scriptId={UPLOAD_PACKAGE_SCHEDULE_SCRIPT_ID} uploadLabel="Upload Package Schedule" />
      <Heading2 heading="Recently Uploaded Package Schedule" />
      <FileUploadsHistory scriptId={UPLOAD_PACKAGE_SCHEDULE_SCRIPT_ID} />
    </div>
  );
};
export default UploadPackageSchedule;
